import React from 'react'
import { chooseWallpaper, conditionalWidth, imageAddress, playSound, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
// import Modal from '../../components/Modal';
// import FormViewer from '../../components/FormViewer';
// import { Doughnut, Bar, Line, Pie } from 'react-chartjs-2';
import TaskSingleView from './TaskSingleView';
// import LoaderButton from '../../components/LoaderButton';
// import Collapsible from 'react-collapsible';
// import SettingsViewer from '../../components/SettingsViewer';
import AddTaskModal from './AddTaskModal';
import HttpServices from '../../utils/Http.services';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import StagesManager from '../../components/StagesManager';
import store from '../../stores/storeConfig';
import SocketServices from '../../utils/socket.services';
import SidebarView from '../../components/SidebarView';
import Subtasks from './Eagleviews/subtasks';
import AddSubtaskSidePanel from './Eagleviews/addSubtaskSidePanel';
import ViewsIntractionActions from '../../components/ViewsIntractionActions';
import ViewSwitcher from '../../components/ViewSwitcher';
import DeskNotifView from '../DeskViews/DeskNotifView';
import FormViewer from '../../components/FormViewer';
import SelectInput from '../../components/inputs/SelectInput';
import Header from '../../components/header/Header';


class DeskHome extends React.Component {
    state = {

        // updates: [
        //     { title: 'Task has been done', task: 'Fix antbuildz UI issues', icon: '/assets/icons/applets/general/fast1.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { title: 'rooms', task: 'Your Rooms', icon: '/assets/icons/applets/general/warning.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { title: 'schedule', task: 'Schedule', icon: '/assets/icons/applets/general/clock.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { title: 'history', task: 'History', icon: '/assets/icons/applets/general/help.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { title: 'history', task: 'History', icon: '/assets/icons/applets/general/help.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { title: 'history', task: 'History', icon: '/assets/icons/applets/general/help.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { title: 'history', task: 'History', icon: '/assets/icons/applets/general/help.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        //     { title: 'history', task: 'History', icon: '/assets/icons/applets/general/help.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },

        //     { title: 'history', task: 'History', icon: '/assets/icons/applets/general/help.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        // ],
        // tasks: [],
        // appletTitle: '',
        taskStack: [],
        addSubtasks: {},
        // chartOption: {
        //     legend: {
        //         display: false
        //     },
        //     responsive: true,
        //     maintainAspectRatio: false
        // },

        data: {
            labels: ['{{lang}}Done', "{{lang}}Not Done"],
            datasets: [{
                data: [1, 2],
                backgroundColor: ['#ee5050', '#007aff']
            }]

        },

        // addList: [
        //     { label: '{{lang}}desk.File', icon: '/assets/icons/useful/clip.svg', },
        //     { label: '{{lang}}desk.Drive', icon: '/assets/icons/useful/save.png', },
        //     { label: '{{lang}}desk.Editor', icon: '/assets/icons/useful/text.svg', },
        //     { label: '{{lang}}desk.Voice', icon: '/assets/icons/useful/microphone.svg', },

        // ],
        showSubTasks: [],
        // taskSideBar: {},

        // currentTab: 0,

        // tabView: "",
        bg: 'linear-gradient(90deg, #B51F68, #DE2880)',
        bg2: 'rgba(136, 24, 79, 0.2)',


        // header: [
        //     { type: 'SelectInput', key: 'applet', information: { type: 'api', address: 'getMyFramesByType', filter: { features: 'Tasking' }, fields: { title: 'applet.name', value: 'applet._id' }, placeholder: '{{lang}}Select The Applet ...', required: true } },
        // ],
        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}desk.Task Title', inplaceEditable: true, placeholder: '{{lang}}desk.insert', required: false, disabled: true }, showMain: true },
            { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}desk.Due Date', inplaceEditable: true, placeholder: '{{lang}}desk.Date', required: true }, showMain: true },
            // { key: 'priority', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}desk.Priority', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },

            { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}desk.priority', inplaceEditable: true, placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#CA5C72', bgColor: '#FEE9EE' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#CAA55C', bgColor: '#FEF2E9' }, { label: '{{lang}}desk.Low', key: 'low', color: '#00c875', bgColor: '#00c87520' }], required: false } },

            { key: 'assignees', type: 'GlobalUserMultiInput', information: { label: '{{lang}}desk.Assignees', inplaceEditable: true, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },

            { key: 'source', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}desk.Source', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            { key: 'tags', type: 'MultiSelectInput', fullCol: true, information: { label: '{{lang}}desk.Tags', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },

        ],

        actions: {
            edit: { key: "edit", label: '{{lang}}desk.edit', color: '#677dc4', function: this.openEditModal },
            remove: { key: "remove", label: '{{lang}}desk.remove', color: '#ee5050', function: this.openRemoveModal }
        },

        // views: [
        //     { name: '{{lang}}desk.Table', key: 'table', },
        //     // { name: '{{lang}}desk.List', key: 'list', },
        //     { name: '{{lang}}desk.Card', key: 'card', },
        //     { name: '{{lang}}desk.Kanban', key: 'kanban', },
        //     { name: '{{lang}}desk.Gantt', key: 'gantt' },
        //     { name: '{{lang}}desk.Calendar', key: 'calendar', },
        //     // { name: '{{lang}}desk.Form', key: 'form', },
        // ],

        // groupBy: [],

        currentView: "table"

    }

    addSubtask = (menuList) => {
        // console.log('here', menuList)
        let addSubtasks = this.state.addSubtasks
        if (!addSubtasks[menuList]) {
            addSubtasks[menuList] = true
        }
        addSubtasks[menuList] = true
        this.setState({ addSubtasks }, () => {
            this.menuSidebar.openSidebar()
            // console.log('addSubtasks', this.state.addSubtasks)
        })
    }
    showSubtask = () => {
        this.subTaskStageManager.changeStage('showSubTask')

    }

    onClosed = () => {
        let taskStack = this.state.taskStack
        // console.log('1', taskStack)
        taskStack.pop()
        // console.log(taskStack)
        this.setState({ taskStack }, () => {
        })
    }
    onSubClosed = () => {
        this.setState({ showSubTasks: [] }, () => {
        })
    }

    // approveTask = (item, approved) => {
    //     item.approved = approved
    //     SocketServices.emit('approveTask', item)

    // }
    componentDidMount() {
        let filter = {
            // title: { key: 'title', value: 'Antbuildz', operator: 'contains', icase: false }
        }

        // getDBData('desk', filter, {}, (dbResult) => {
        // this.setState({ tasks: dbResult }, () => {
        // this.getMyTasks()
        // })
        // })
        this.initData()
        this.checkApplet()

        window.addEventListener("keydown", this.keyPress)

    }
    // changeSelectValue = (key, value, extra) => {
    //     console.log('key', key)
    //     console.log('value', value)
    //     console.log('extra', extra)
    //     this.setState({ appletTitle: value })
    //     this.props.selectApplet(value)
    // }

    componentDidUpdate(prevProps) {
        if (prevProps.inbox?.desk != this.props.inbox?.desk) {
            this.initData()
        }
        if (prevProps.currentApplet != this.props.currentApplet) {
            // console.log('here', true)
            // console.log(this.props.inbox?.desk)
            this.checkApplet()

        }
    }
    checkApplet = () => {

        let appletTasks = []
        // console.log('current ap', this.props.currentApplet)
        if (this.props.currentApplet) {
            // console.log('this.props.inbox?.desk[i].applet', this.props.inbox?.desk)
            // console.log('this.props.currentApple', this.props.currentApple)
            for (let i = 0; i < this.props.inbox?.desk.length; i++) {
                if (this.props.inbox?.desk[i]?.applet?._id == this.props.currentApplet) {
                    appletTasks.push(this.props.inbox.desk[i])
                }
            }
            // console.log('appletTasks', this.state.appletTasks)
            this.setState({ appletTasks })
        }
        else {
            // console.log('appletTasks', this.state.appletTasks)
            appletTasks = this.props.inbox.desk
            this.setState({ appletTasks })
        }

    }
    componentWillUnmount() {
        window.removeEventListener("keydown", this.keyPress)
    }



    initData() {
        let data = this.props.inbox?.desk

        this.setState({ data })
    }

    // changeTab = (prop, index) => {
    //     this.setState({ currentTab: index })
    //     this.stageManager.changeStage(prop.key)
    // }
    changeStage = (value) => {
        this.subTaskStageManager.changeStage(value)
    }


    keyPress = (e) => {
        if ((e.ctrlKey || e.metaKey) && e?.key == 'n') {
            this.addClicked()
            // this.hideModal()
        }
    }
    // changePage = (item) => {
    //     this.setState({ currentPage: item.key })
    // }

    updateTask = (item, key, value) => {
        if (key == 'title' || key == 'description') {
            let obj = { doc: item, key, value }
            HttpServices.request('updateTask', obj, (fetchResult, fetchError) => {
                if (fetchError) {
                    // console.log(fetchError)
                    return
                }

            })
        }
        else if (key == 'assignees') {

            let obj = { doc: item, key, value }
            HttpServices.request('updateTask', obj, (fetchResult, fetchError) => {
                if (fetchError) {
                    // console.log(fetchError)
                    return
                }

            })
        }
    }
    calculateSubTask = (data, cb) => {

        for (let i = 0; i < data.length; i++) {
            data[i]['**subTaskCount'] = 0
            for (let x = 0; x < data.length; x++) {
                for (let z = 0; z < data[x].parent.length; z++) {
                    if (data[x].parent[z]._id == data[i]._id) {
                        data[i]['**subTaskCount'] += 1
                    }
                }
            }
        }
        // console.log('subtasks count', data)
        cb(data)
        // this.subTaskSidebar.openSidebar()
        // this.subTaskStageManager.changeStage('showSubTask')
    }


    postTask = (data, cb) => {

        let body = data
        // console.log('body is ', body);
        HttpServices.request('addTask', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            // console.log(fetchError)
            // console.log(fetchResult)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                cb(null, fetchError)
                return
            }
            playSound('newMessage')
            this.calculateSubTask([fetchResult.info], (data) => {
                if (!Array.isArray(data)) {
                    data = [data]
                }
                store.dispatch(actions.appendTask(data))
                // console.log('task list is :', this.props.inbox.desk)
                // this.setState({ tasks: fetchResult.info })

            })
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
            cb(fetchResult.info)
        })

    }

    // setData = (key, value) => {
    //     this.setState({ [key]: value })

    //     console.log("this is key value", key, value)
    // }


    // taskDone = (item) => {
    //     let tasks = this.props.inbox.MyTasks

    //     let stage = '1'

    //     this.changeTaskStage(item._id, stage, () => {
    //         tasks.forEach((task, index) => {
    //             if (item._id == task._id) {
    //                 tasks[index].done = !item.done
    //             }
    //         });
    //     })

    //     this.setState({ tasks })
    // }

    // openTask = (item) => {
    //     let taskSideBar = this.state.taskSideBar
    //     taskSideBar[item._id] = item
    //     this.setState({ taskSideBar })
    // }
    // changeTaskStage = (_id, stage, cb) => {

    //     let body = { _id, stage }

    //     HttpServices.request('changeTaskStage', body, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingData: false })

    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
    //             cb(null, fetchError)
    //             return
    //         }
    //         playSound('newMessage')
    //         this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
    //         cb(fetchResult.info)
    //     })

    // }


    showInfo = (item) => {
        let data = item
        // this.getSubtask(data, () => {
        this.setState({ currentData: data }, () => {
            this.addTaskStack(data)
        })
        // })

        // this.addModal.showModal()
    }
    addTaskStack = (data) => {
        let taskStack = [...this.state.taskStack]
        taskStack.push(data)
        this.setState({ taskStack }, () => {
            setTimeout(() => {
                console.log('taskStack', this.state.taskStack)
                this["sidebarView-" + data._id].open()
            }, 1);

        })
    }

    closeSidebar = () => {
        this.setState({ sideOpen: false })
        this.sidebarView.closeSidebar()
    }

    addClicked = (open) => {
        this.addTaskModal.modal.showModal()
    }

    // changeView = (prop) => {
    //     this.setState({ currentView: prop.key })
    // }
    // liveChange = (data, initData, key, value, extra, full) => {
    //     console.log('changed key', key)
    //     this.props.selectApplet(value)
    // }

    changeValue = (key, value, extra) => {
        // console.log(key, value, extra)
        let data = this.state.data
        data[extra.index][key] = value
        this.setState({ data })
    }


    render() {

        // console.log(this.state.data)
        let headertype = this.props.isApplet ? 'applet' : 'portal'

        return (

            <div className="window-content-radius w-100 h-100 " style={{ backgroundColor: '#F5F5F5' }}>
                <div className='d-flex w-100 h-100'>
                    <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: '12', md: '12' }}>

                        <div className='window-content-radius   w-100 h-100 d-flex scroll-no-scrollbar h-100 ' style={{ backgroundColor: 'rgb(248,248,249)' }}>
                            <div className='w-100' style={{ flex: 1 }}>
                                {/* <div className='w-100 window-content-radius-top pb-0' style={{ zIndex: 10, backgroundColor: '#ddd' }}>
                                    <div className='px-3 py-2 flexc'>
                                        <div className='flexc  w-100' style={{}}>
                                            <img src="/assets/icons/portals/Asset 2.svg" alt="" height={30} />

                                            <div className='w-100 mld-2 flexc'>
                                                <h2 className="m-0 text-normal mb-0 " >Yonnect Desk</h2>
                                                {console.log('this.props.isApplet', this.props.isApplet)}
                                                {!this.props.isApplet && (

                                                    <div className='px-3 py-1 mx-2' style={{ width: '100%', maxWidth: 100, borderRadius: '30px', backgroundColor: '#2a2a2e20' }} >
                                                        <SelectInput ref={el => this.select = el} changeValue={this.changeSelectValue} data={this.state.appletTitle} header={{ key: 'applet', information: { type: 'api', address: 'getMyFramesByType', filter: { features: 'Tasking' }, fields: { title: 'applet.name', value: 'applet._id' }, placeholder: 'All' } }} />
                                                    </div>
                                                )}

                                                <button onClick={() => this.props.goToHub()} className='flexc  cursor-pointer' style={{ maxWidth: 450 }}>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <DeskNotifView showRequests={() => this.showRequests()} title={"You have some new tasks"} button={"SEE REQUESTS"} requestNumbers={this.props.inbox.pendingTask.length} approveTask={this.approveTask} />


                                <ViewsIntractionActions background={'#fff'} color={'#777'} invert={true} views={this.state.views} view={this.state.currentView} headers={this.state.headers} data={this.props.inbox?.desk} action={this.state.actions} width={this.props.width} changeView={this.changeView} /> */}

                                <Header language={this.props.language} width={this.props.width} toolbar={true} type={'applet'} headertype={headertype} title={translate('desk.Desk')} applet={this.props.applet} color={this.state.bg} color2={this.state.bg2} />

                                <div className='w-100' style={{ backgroundColor: '#fff' }}>
                                    <ViewSwitcher data={this.state.appletTasks} view={this.state.currentView} headers={this.state.headers} actions={this.state.actions} width={this.props.width} functionsHandler={this.functionsHandler} submitForm={this.submitForm} changeValue={this.changeValue}
                                    />

                                </div>



                                {/* <StagesManager ref={el => this.stageManager = el}>
                                    <EagleView approveTask={this.approveTask} showInfo={this.showInfo} stage={0} stageName={'eagle'} />
                                    <List stage={1} stageName={'list'} />
                                    <Table stage={2} stageName={'table'} />
                                    <Kanbanview stage={3} stageName={'kanban'} />
                                    <Gantt stage={4} stageName={'gantt'} />
                                    <Workload stage={5} stageName={'Workload'} />
                                    <Calendar stage={6} stageName={'calendar'} page={'desk'} />
                                    <Timeline stage={7} stageName={'timeline'}
                                    />
                                </StagesManager> */}


                            </div>
                        </div>

                    </Responsive>
                </div>


                <div className={"position-absolute"} style={{ bottom: '10px', right: 10, zIndex: 10 }}>
                    <button onClick={() => this.addClicked()} className='px-1 py-1  flexcb ' style={{ backgroundColor: "#0093E9", backgroundImage: " linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)", borderRadius: 8, color: '#fff', transition: 'all 0.5s', boxShadow: '0px 0px 10px #10101030' }}>
                        <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap', zIndex: 10 }}>{translate("desk.New Task")}</p>
                        <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 8 }}>
                            <img className='invert' src='/assets/icons/plus.svg' height={18} />
                        </div>
                    </button>
                </div>



                <AddTaskModal ref={el => this.addTaskModal = el} language={this.props.language} postTask={this.postTask} currentApplet={this.props.currentApplet} startDate={this.props.startDate} endDate={this.props.endDate} />


                {/* <Subtasks ref={el => this.sideBar = el} /> */}

                {/* <div className={"sidePanel h-100  blur-back " + (conditionalWidth(this.props.width, { xs: '' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ width: conditionalWidth(this.props.width, { xs: '90%', sm: '90%', md: '33.3%', lg: "25%", xl: "25%" }) }} > */}

                <div onClick={() => { this.closeSidebar() }} className={'position-fixed top-0 left-0 w-100 h-100 fadein ' + (this.state.sideOpen ? '' : 'd-none')} style={{ zIndex: 10, backgroundColor: '#10101040' }}>

                </div>

                {/* <div className={"sidePanel h-100  " + (conditionalWidth(this.props.width, { xs: '' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ zIndex: 20, maxWidth: 400, width: conditionalWidth(this.props.width, { xs: '90%', md: '80%', }) }} >
                    <div className='sidePanel-content h-100 blur-back' > */}
                {this.state.taskStack.map((prop) => {
                    // console.log('task stack', prop)
                    return (
                        <SidebarView onClosed={this.onClosed} onSubClosed={this.onSubClosed} width={this.props.width} ref={el => this["sidebarView-" + prop._id] = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                            <StagesManager ref={el => this.subTaskStageManager = el} height={'100%'}>
                                <TaskSingleView key={prop._id} data={prop} ref={el => this.taskView = el}
                                    showSubtask={this.showSubtask}
                                    addSubtask={this.addSubtask} showSubTasks={this.state.showSubTasks} stage={0} stageName={'taskView'} updateTask={this.updateTask} />
                                <Subtasks getSubtask={this.getSubtask} showInfo={this.showInfo} changeStage={this.changeStage} ref={el => this.sideBarSubTask = el} showSubTasks={this.state.showSubTasks} stage={1} stageName={'showSubTask'} data={prop} />
                            </StagesManager>
                        </SidebarView >
                    )
                })}


                <SidebarView width={this.props.width} ref={el => this.menuSidebar = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                    <AddSubtaskSidePanel ref={el => this.addSubTaskModal = el} postTask={this.postTask} language={this.props.language} />
                </SidebarView>


            </div >



        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeskHome);
// export {VIEW_NAVBAR_STATE}
